import { ManifestComponentExtensionType } from '../ManifestStore';
import { AbstractExternalAPIHandler } from './AbstractExternalAPIHandler';
export class ExternalDataHandler extends AbstractExternalAPIHandler {
  constructor(dm, hostAPI, manifestStore, manifestDefaultValues) {
    super(dm, hostAPI, manifestStore);
    this.dm = dm;
    this.hostAPI = hostAPI;
    this.manifestStore = manifestStore;
    this.manifestDefaultValues = manifestDefaultValues;
  }

  /**
   * TODO: probably it should be sync
   */
  getData(editorPointer, type) {
    switch (type) {
      case ManifestComponentExtensionType.BLOCKS:
      case ManifestComponentExtensionType.BUILDER:
        {
          const contextualEditorPointer = this.hostAPI.stage.getPointerWithCurrentVariants(editorPointer);
          return this.hostAPI.components.data.getData(contextualEditorPointer);
        }
      case ManifestComponentExtensionType.OOI:
        {
          // we need to handle isMobile as well
          const manifest = this.manifestStore.getManifestByEditorPointer(editorPointer);
          const manifestData = manifest == null ? void 0 : manifest.data;
          if (!manifestData) {
            return Promise.resolve({});
          }
          const dataWithValues = {};
          Object.keys(manifestData).forEach(key => {
            this.dm.tpa.data.comp.get(editorPointer.documentPointer, key, result => {
              dataWithValues[key] = result[key];
            });
          });
          return Promise.resolve(dataWithValues);
        }
      default:
        throw new Error('not implemented');
    }
  }

  /**
   * TODO: probably it should be sync
   */
  async setData(editorPointer, type, data) {
    switch (type) {
      case ManifestComponentExtensionType.BLOCKS:
      case ManifestComponentExtensionType.BUILDER:
        {
          const contextualEditorPointer = this.hostAPI.stage.getPointerWithCurrentVariants(editorPointer);
          await this.hostAPI.components.data.setData(contextualEditorPointer, data);
          return Promise.resolve();
        }
      case ManifestComponentExtensionType.OOI:
        {
          const compRef = editorPointer.documentPointer;
          return new Promise(resolve => {
            this.dm.tpa.data.setMultiple(compRef, data, 'COMPONENT', result => {
              resolve();
            });
          });
        }
      default:
        throw new Error('not implemented');
    }
  }
  getDefaultValue(editorPointer, _type, dataItemId) {
    return this.manifestDefaultValues.getDefaultDataValueByEditorPointer(editorPointer, dataItemId);
  }
}
//# sourceMappingURL=ExternalDataHandler.js.map